import { Fragment, MouseEvent } from "react";
import { FormattedMessage } from "react-intl";
import { Mail } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useApiCall } from "@dzambalaorg/react-hooks";
import { EmailType } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

const excludedEmailTypes = [
  EmailType.RAFFLE_PRIZE,
  EmailType.LOTTERY_PRIZE,
  EmailType.STAKING_BALANCE,
  EmailType.SUPPORT_LETTER,
];

export const Email = () => {
  const { fn, isLoading } = useApiCall(async (api, email: string) => {
    return api.fetchJson({
      url: `/emails/${email}`,
      method: "POST",
    });
  });

  const sendEmail =
    (email: EmailType) =>
    (e: MouseEvent): void => {
      e.preventDefault();
      void fn(null as unknown as any, email);
    };

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "emails"]} />

      <PageHeader message="pages.emails.title" />

      <ProgressOverlay isLoading={isLoading}>
        <List>
          {Object.values(EmailType)
            .filter(type => !excludedEmailTypes.includes(type))
            .map(email => (
              <List.ItemButton key={email} onClick={sendEmail(email)}>
                <List.ItemIcon>
                  <Mail />
                </List.ItemIcon>
                <List.ItemText>
                  <FormattedMessage id={`enums.emailType.${email}`} />
                </List.ItemText>
              </List.ItemButton>
            ))}
        </List>
      </ProgressOverlay>
    </Fragment>
  );
};
